import _Collections from "@mui/icons-material/Collections";
import React from 'react';
import { COLORS } from '@fupa/fupa-uikit';
import { Heading, IconContainer, LinkContainer, LinkText, StyledLink, Subtitle, Title, Wrapper } from 'app/components/styles/districtModules/headerStyles';
export default function MediaModuleHeader(_ref) {
  let {
    pathname
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MediaModuleHeader",
    "data-sentry-source-file": "MediaModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.deepBlue,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "MediaModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Collections, {
    style: {
      color: COLORS.white,
      fontSize: 'inherit'
    },
    "data-sentry-element": "Collections",
    "data-sentry-source-file": "MediaModuleHeader.tsx"
  })), /*#__PURE__*/React.createElement(Heading, {
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "MediaModuleHeader.tsx"
  }, /*#__PURE__*/React.createElement(Title, {
    variant: "subheading2",
    component: "span",
    "data-sentry-element": "Title",
    "data-sentry-source-file": "MediaModuleHeader.tsx"
  }, "Media"), /*#__PURE__*/React.createElement(Subtitle, {
    variant: "caption3",
    "data-sentry-element": "Subtitle",
    "data-sentry-source-file": "MediaModuleHeader.tsx"
  }, "Die aktuellen Fotos und Video-Highlights")), pathname ? /*#__PURE__*/React.createElement(LinkContainer, null, /*#__PURE__*/React.createElement(StyledLink, {
    to: "".concat(pathname, "/media"),
    decoration: "underline",
    rel: "nofollow"
  }, /*#__PURE__*/React.createElement(LinkText, {
    variant: "caption3"
  }, 'Alle Inhalte >'))) : null);
}